<template>
  <div class="main-container" v-if="formData">
    <Form ref="form" class="page-form" :model="formData" :label-width="160" :disabled="disabled">
      <!-- 保单信息 -->
      <detail :formData="formData"></detail>

      <!-- 应缴保费信息 -->
      <fee :formData="formData"></fee>

      <!-- 实际缴费信息 -->
      <paymentHistory :formData="formData"></paymentHistory>
    </Form>

    <div class="bottom-btn">
      <Button type="primary" ghost @click="back($route.query.backUrl)">返回</Button>
      <Button v-if="['0', '1', '2', '3', '4'].includes(formData.renewalState) && !disabled" type="primary" @click="save">提交</Button>
    </div>
  </div>
</template>

<script>
import detail from './detail';
import fee from './fee';
import paymentHistory from './paymentHistory';
import { common } from '@/api/mixins';
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
export default {
  mixins: [common],
  components: {
    detail,
    fee,
    paymentHistory
  },
  data() {
    return {
      policyStatus: JSON.parse(localStorage.dic)['POLICY_STATUS'], // 保单状态
      visible: false,
      loading: false,
      companyList: [],
      formData: null,
      disabled: true
    };
  },
  async mounted() {
    const nameMap = {
      1: '未缴费详情',
      2: '提交对账详情',
      3: '已确认缴费详情',
      4: '保费逾期详情'
    };
    this.id = this.$route.query.id;
    if (this.id) {
      await this.getDetailData(this.id);
    } else {
      this.formData = {
        attachment: [],
        policyPayments: [],
        policyInfo: []
      };
    }
  },
  methods: {
    // 获取缴费详情
    getDetailData(id) {
      this.$notice.showLoading();
      this.$http({
        url: '/buz/policy/renewal/detail',
        type: 'GET',
        data: {
          id
        }
      })
        .then(res => {
          const formData = res.data;
          formData.payerName = formData.payerName || formData.policyInfo.name || '';
          formData.customerType = formData.payerName && formData.policyInfo.name == formData.payerName ? '1' : '';
          formData.bank = formData.bank || formData.policyInfo.bank || '';
          formData.bankCardNo = formData.bankCardNo || formData.policyInfo.bankCardNo || '';
          if (typeof formData.policyInfo?.currencyType == 'number') {
            formData.policyInfo.currencyType = formData.policyInfo?.currencyType.toString();
          }
          if (formData?.policyPayments) {
            formData.policyPayments.forEach(item => {
              if (Array.isArray(item.attachments) && item.attachments.length) {
                item._img1 = item.attachments
                  .filter(item => item.type == '缴费凭证')
                  .map(i => {
                    i.id = item.id;
                    return i;
                  });
                item._img2 = item.attachments
                  .filter(item => item.type == '账户证明')
                  .map(i => {
                    i.id = item.id;
                    return i;
                  });
              } else {
                item._img1 = [];
                item._img2 = [];
              }
              item.currency = typeof item.currency == 'number' ? item.currency.toString() : item.currency;
            });
          }

          if (formData.attachment && formData.attachment.type) {
            formData.attachment = [formData.attachment];
          }
          this.disabled = userInfo.tenantId !== res.data.tenantId;
          this.formData = formData;
        })
        .finally(() => {
          this.$notice.hideLoading();
        });
    },
    // 保存
    save() {
      this.$refs.form.validate((valid, obj) => {
        if (valid) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.$notice.showLoading();
          const formData = JSON.parse(JSON.stringify(this.formData));
          const url = '/buz/policy/renewal/submit';
          // let prevCurrency = '';
          const _policyPayments = formData.policyPayments || [];
          // for (let i = 0; i < _policyPayments.length; i++) {
          //   const item = _policyPayments[i];
          //   if (prevCurrency === '') {
          //     prevCurrency = item.currency;
          //   }
          //   if (prevCurrency != item.currency) {
          //     this.$notice.error('多条缴费记录货币类型需保持一致');
          //     this.$notice.hideLoading();
          //     window.setTimeout(() => {
          //       this.loading = false;
          //     }, 300);
          //     return;
          //   }
          // }
          const data = {
            id: formData.id,
            paidPremium: formData.paidPremium,
            payerName: formData.payerName,
            bank: formData.bank,
            bankCardNo: formData.bankCardNo,
            customerType: formData.customerType,
            policyPayments: _policyPayments.map(item => {
              const attachments = [];
              if (item?._img1?.[0]) {
                attachments.push(
                  ...item?._img1?.map(item =>
                    Object.assign(
                      {
                        fileName: '',
                        path: '',
                        type: '缴费凭证'
                      },
                      item
                    )
                  )
                );
              }
              if (item?._img2?.[0]) {
                attachments.push(
                  ...item?._img2?.map(item =>
                    Object.assign(
                      {
                        fileName: '',
                        path: '',
                        type: '账户证明'
                      },
                      item
                    )
                  )
                );
              }
              const obj = {
                paymentWay: item.paymentWay,
                currency: Number(item.currency),
                amount: item.amount,
                paymentDate: item.paymentDate,
                attachments,
                submitAccountDate: item.submitAccountDate,
                status: item.status,
              };
              if (item.id) {
                obj.id = item.id;
              }
              return obj;
            })
          };

          this.$http({
            url,
            type: 'POST',
            data
          })
            .then(() => {
              this.$notice.success('操作成功');
              this.getDetailData(this.id);
            })
            .finally(() => {
              this.$notice.hideLoading();
              window.setTimeout(() => {
                this.loading = false;
              }, 300);
            });
        }
      });
    },
    addKey(saveList, data, key, type) {
      data[key].forEach(item => {
        item.type = type;
        saveList.push(item);
      });
      delete data[key];
    }
  }
};
</script>
<style lang="scss" scoped>
.main-container {
  padding-bottom: 100px;
}

.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;
  z-index: 10;

  .ivu-btn {
    width: 140px;
    height: 35px;
  }

  .ivu-btn + .ivu-btn {
    margin-left: 20px;
  }
}
</style>
